//----------------------------------------------------------
// Generated file, DO NOT EDIT.
// To regenerate this file, run "GenerateConstants.cmd" .

// Generated data for the following assemblies:
// Microsoft.Azure.Pipelines.Checks.WebApi
// Microsoft.Azure.Pipelines.Checks.Common
//----------------------------------------------------------


/// <amd-module name="Environments/Landing/Generated/Constants" />
export module FeatureFlagConstants {
    export const EnableChecksScalabilityPhase1Warnings = "Pipelines.Checks.EnableChecksScalabilityPhase1Warnings";
    export const EnableChecksScalabilityPhase2Errors = "Pipelines.Checks.EnableChecksScalabilityPhase2Errors";
    export const EnableChecksScalabilityPhase3FailCheckRuns = "Pipelines.Checks.EnableChecksScalabilityPhase3FailCheckRuns";
    export const EnableChecksScalabilityResourceIssues = "Pipelines.Checks.EnableChecksScalabilityResourceIssues";
    export const EnableDisabledChecksFeature = "Pipelines.Checks.EnableDisabledChecksFeature";
    export const ResourceListOptimizations = "Pipelines.Policy.ResourceListOptimizations";
}

export module ResourceTypeNames {
    export const ServiceEndpoint = "endpoint";
    export const Queue = "queue";
    export const SecureFile = "securefile";
    export const VariableGroup = "variablegroup";
    export const Environment = "environment";
    export const AgentPool = "agentpool";
    export const Repository = "repository";
}

